import React, { useContext } from "react";
import { ICandidateData, ICandidateResultData, ICandidateResponsefromAPI, IReqsResultData } from '../types/candidates';
import moment from "moment";

export const filterCandName: any[] = [];
export const filterOverallCompatibility: any[] = [];
export const filterAppStatus: any[] = [];
export const reqsListStatusFilter: any[] = [];
export const reqsListCategoryFilter: any[] = [];

export const transformCandidateResultData = (candidateResultSet: ICandidateResponsefromAPI): ICandidateResultData => {
    return <ICandidateResultData>{
        nodes: transformSortLinks(candidateResultSet.applicationSearchResults),
        resultsCount: candidateResultSet.applicationSearchResults.length,
        totalCount: candidateResultSet.totalCount,
        maxResults: candidateResultSet.maxResults,
    };
}

const populateSortFilter = (candidate: ICandidateData) => {
    const filterNameValue = { value: candidate.fullName, label: candidate.fullName };
    let candNameIndex = filterCandName.findIndex(object => object.value === candidate.fullName);
    if (candNameIndex === -1) {
        filterCandName.push(filterNameValue);
    }
}

export const setFilterAppStatusFilterValues = (values: Array<any>) => {
    filterAppStatus.length = 0;
    values.forEach((i: any) => filterAppStatus.push(i));
}

export const setFilterOverallCompatibility = (values: Array<any>) => {
    filterOverallCompatibility.length = 0;
    values.forEach((i: any) => filterOverallCompatibility.push(i));
}

export const transformSortLinks = (data: any) => {
    let map: any = [];
    if(data && data.length > 0) {
        data.forEach((candidate: ICandidateData) => {
            populateSortFilter(candidate);
            map.push(candidate);
        });
    }
    return map;
}

const getLastUpdatedToDate = (value: string) => {
    switch (value) {
        case '1': return 6;
        case '2': return 29;
        case '3': return 89;
        default: return 0;
    }
}

export const transformFilterData = (filterData: any) => {
    const updatedFilterPayload = { lastUpdated: <any>{}, workflowStateId: <any>[], overallCompatibility: <any>[], keywords: '' };
    filterData.appliedSearchFilters.forEach((filter: any) => {
        if (filter.searchFilterId === 'LastUpdated') {
            if(filter.filterValues[0].value === 'any'){
                updatedFilterPayload.lastUpdated = null;
            } else {
                updatedFilterPayload.lastUpdated = {
                    from: moment().subtract(getLastUpdatedToDate(filter.filterValues[0].value), 'd').format('YYYY-MM-DD'),
                    to: moment().format('YYYY-MM-DD'),
                    type: 2,
                }
            }
        } else if (filter.searchFilterId === 'candidateState') {
            if (filter.filterValues[0].value === 'all') {
                if (updatedFilterPayload.workflowStateId?.length > 1 || updatedFilterPayload.workflowStateId?.includes(-1)) { // Only nullify `workflowStateId` if it contains ONLY `-1` (Which is Candidate Status: Active) and if nothing else was applied (i.e.: Application Status filter, which uses the same property `workflowStateId`).
                    updatedFilterPayload.workflowStateId = null;
                }
            } else {
                updatedFilterPayload.workflowStateId.push(-1);
            }
        } else if (filter.searchFilterId === 'AppStatus') {
            filter.filterValues.forEach((state: any) => {
                updatedFilterPayload.workflowStateId ? updatedFilterPayload.workflowStateId.push(state.value) : updatedFilterPayload.workflowStateId = [state.value];
            });
        } else if (filter.searchFilterId === 'candidateName') {
            updatedFilterPayload.keywords = filter.filterValues[0].value;
        } else if (filter.searchFilterId === 'overallCompatibility') {
            filter.filterValues.forEach((state: any) => {
                updatedFilterPayload.overallCompatibility ? updatedFilterPayload.overallCompatibility.push(state.value) : updatedFilterPayload.overallCompatibility = [state.value];
            });
        }
    });
    if(updatedFilterPayload.keywords === '' && filterData.q && filterData.q !== ''){
        updatedFilterPayload.keywords = filterData.q;
    }
    return updatedFilterPayload;
}

export const filterDuplicateFilters = (searchFilters: any) => {
    let newFilters = searchFilters
    
    // checking for candidateState duplicate
    const allCandidatesSelected = newFilters.find(filter => filter.searchFilterId === 'allCandidates')
    const candidateStateSelected = newFilters.find(filter => filter.searchFilterId === 'candidateState')
    if (candidateStateSelected && allCandidatesSelected) {
        newFilters = newFilters.filter((filter) => filter.searchFilterId !== 'allCandidates')
    }

    return newFilters
}

export const setActiveFilterChip = (selectFilterData: any) => {
    let selectedFilterChip: any = [];
    selectFilterData.appliedSearchFilters.forEach((filter: any) => {
        let filterObj = {
            searchFilterId: filter.searchFilterId,
            displayLabel: filter.displayLabel,
            filterValues: filter.filterValues
        }
        selectedFilterChip.push(filterObj);
    });
    return selectedFilterChip;
}

export const transformReqsFilterData = (data:any) => {
    data.statusFilter.optionValues.forEach((filter: any) => {
        let filterObj = {
            label: filter.name,
            value: filter.key,
            mine: filter.mine
        }
        reqsListStatusFilter.push(filterObj);
    });
    data.filters.Categories.forEach((category: any) => {
        let categoryObj = {
            label: category.name,
            value: category.EId
        }
        reqsListCategoryFilter.push(categoryObj);
    });
}

export const transformReqsListData = (Reqs:any) => {
    let transformedReqsList: IReqsResultData = {
        nodes: [],
        totalCount: Reqs.jobCount ? Reqs.jobCount : 0,
        resultsCount: 10,
        showCompany: Reqs.showCompany
    };
    Reqs.jobs.forEach((job: any) => {
        transformedReqsList.nodes.push(job);
    });
    return transformedReqsList;
}

export const validateDuplicateCandidates = (selectedCandidate: any, CandList: any) => {
    let selectedReqID: any[] = [];
    selectedCandidate.forEach((e: any) => {
        CandList.forEach((cand: any)=>{
            if(e === cand.EId){
                selectedReqID.push(cand.jobEId);
            }
        })
    });
    return selectedReqID.every( val => val === selectedReqID[0]);
  }